<script setup lang="ts">
import { Color } from '@goldcast/utils';
import { computed, provide } from 'vue';

import { useStore } from '@/store';

type ThemeMode = 'user-configured' | 'fixed' | 'inherit';

const props = defineProps<{
  mode: ThemeMode;
  fixedTheme?: {
    primary: string;
    secondary: string;
    primaryText: string;
    secondaryText: string;
  };
}>();

const store = useStore();
const currentEvent = computed(() => store.state.event.event);
const themeContext = computed(() => {
  if (props.mode === 'fixed') {
    return {
      '--theme-primary-color': store.state.event.goldcastThemeStyles['--primary-shade-1000'],
      '--theme-secondary-color': store.state.event.goldcastThemeStyles['--primaryText-shade-50'],
      '--theme-primary-text-color': store.state.event.goldcastThemeStyles['--primaryText-shade-50'],
      '--theme-secondary-text-color': store.state.event.goldcastThemeStyles['--primary-shade-1000']
    };
  }

  if (props.mode === 'user-configured') {
    return {
      '--theme-secondary-color': new Color(currentEvent.value?.theme_obj?.theme_secondary_color).channels,
      '--theme-primary-color': new Color(currentEvent.value?.theme_obj?.theme_primary_color).channels,
      '--theme-primary-text-color': new Color(currentEvent.value?.theme_obj?.primary_text_color).channels,
      '--theme-secondary-text-color': new Color(currentEvent.value?.theme_obj?.secondary_text_color).channels
    };
  }

  // inherit mode - use parent theme or default
  return {};
});

provide('theme-context', themeContext.value);
</script>

<template>
  <div :style="themeContext">
    <slot />
  </div>
</template>
